export const collection = {
    noData: '아직 NFT를 소유하지 않았습니다.',
    title: '귀하의 컬렉션',
};
